<!-- 非必要不修改 -->
<template>
  <div class="l-table">
    <el-table :data="data" v-bind="tableProps">
      <el-table-column v-for="(item, index) in columns" :align="align" :key="index" v-bind="item">
        <template #default="scope">
          <slot :name="item.prop" v-bind="scope">
            {{ scope.row[item.prop] }}
          </slot>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableProps: {
      default: function () {
        return {}
      },
      type: Object
    },
    align:{
      default: 'center',
      type: String

    },
    data: {
      default: () => [],
      type: Array
    },
    columns: {
      default: () => [],
      type: Array
    },
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="scss"></style>